import React, { useEffect, useState } from 'react';
import '@bepro-travel/fe.shared/dist/styles.css';
import 'react-form-builder2/dist/app.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'rc-checkbox/assets/index.css';
import 'react-loading-skeleton/dist/skeleton.css';
import './styles/index.scss';
import './styles/variables.scss';
import './styles/components.scss';
import './styles/home.scss';
import './styles/responsive.scss';
import { ToastContainer } from 'react-toastify';
import Router from './components/Router.tsx';
import ReactDOM from 'react-dom/client';
import { configureAxios, i18nconfig } from './utils.tsx';
import { auth } from '@bepro-travel/fe.shared';
import CookieAccept from './components/CookieAccept.tsx';

const App = () => {
  const [isAppReady, setIsAppReady] = useState(false);

  useEffect(() => {
    (async () => {
      configureAxios();
      i18nconfig();
      await auth.getUserToken();

      setTimeout(() => {
        setIsAppReady(true);
      });
    })();
  }, []);
  return (
    <div className="flex-column" style={{ minHeight: '100vh' }}>
      {isAppReady && <Router />}
      <CookieAccept />
      <ToastContainer />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as any);
root.render(<App />);
